import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomLayoutsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomLayoutsQuery = { __typename?: 'Query', CustomLayout?: { __typename?: 'CustomLayoutEntity', id: string, firmAccountId?: string | null, headerBackgroundColor?: string | null, headerFontColor?: string | null, logo?: string | null, pixelCode?: string | null } | null };

export type GenerateOtpQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateOtpQuery = { __typename?: 'Query', generateOTP: { __typename?: 'generateOtpEntity', codeQR: string, key: string } };

export type GetLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'LanguagesEntity', id: string, lang: string, description?: string | null }> };

export type GetJobsByClientIdQueryVariables = Types.Exact<{
  clientId: Types.Scalars['String'];
  firmAccountId: Types.Scalars['String'];
}>;


export type GetJobsByClientIdQuery = { __typename?: 'Query', jobsByClientId: Array<{ __typename?: 'TaxYearInterviewEntity', id: string, taxYearId: string, preparedId?: string | null, reviewedId?: string | null, notes?: string | null, assignedAt: any, completedAt?: any | null, reviewStatus?: Types.ReviewStatus | null, preparerAcceptedAt?: any | null, createAt: any, updateAt: any, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, uniqueLink?: string | null, UserInformation: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } } | null, ReviewedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } } | null, Interviews?: { __typename?: 'InterviewEntity', id: string, firmAccountId: string, name: string, isTemplate: boolean, isLive: boolean, drakePackage?: string | null, createAt: any, updateAt: any } | null, Reviews?: Array<{ __typename?: 'ReviewsEntity', id: string, reviewValue?: number | null, taxYearInterviewId?: string | null }> | null, ProgressStatuses?: { __typename?: 'ProgressStatusesEntity', id: string, firmAccountId: string, status: string, underlyingStatus: Types.TaxYearStatus, createAt: any, updateAt: any } | null, Tasks?: Array<{ __typename?: 'TaskEntity', id: string, taxYearInterviewId?: string | null, taskType?: Types.TaskType | null, completedAt?: any | null, deletedAt?: any | null, createAt: any, updateAt: any, RequestedFiles?: { __typename?: 'RequestedFilesEntity', taskId?: string | null, fileName: string, notes?: string | null, completedAt?: any | null } | null }> | null, FileRequests?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, firmAccountId?: string | null, clientId?: string | null, notes?: string | null, title?: string | null, compiledHash?: string | null, signedFileId?: string | null, compiledFileId?: string | null, taxYearInterviewId: string, taskId?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, createAt: any, updateAt: any }> | null, TaxYear?: { __typename?: 'TaxYearEntity', id: string, year: number, Entity?: { __typename?: 'Entity', id: string, UserFirmAccount?: Array<{ __typename?: 'UserFirmAccountEntity', id: string, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, ownerId?: string | null, uniqueLink?: string | null } | null }> | null } | null } | null }>, FirmAccountById: { __typename?: 'FirmAccountEntity', id: string, ownerId?: string | null } };

export type GetFilesByTaxYearInterviewIdQueryVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type GetFilesByTaxYearInterviewIdQuery = { __typename?: 'Query', FilesByTaxYearInterviewId: Array<{ __typename?: 'FileEntity', id: string, s3Key?: string | null, name?: string | null, folder?: string | null, createAt: any, updateAt: any, size?: number | null, SignedFile?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, firmAccountId?: string | null, clientId?: string | null, notes?: string | null, title?: string | null, compiledHash?: string | null, signedFileId?: string | null, compiledFileId?: string | null, taxYearInterviewId: string, taskId?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, createAt: any, updateAt: any, FileApprovals?: Array<{ __typename?: 'FileApprovalEntity', id: string, expiresAt: any, fileRequestId: string, email: string, name: string, kbaEnable: boolean, completedAt?: any | null, createAt: any, updateAt: any }> | null }> | null, CompiledFile?: Array<{ __typename?: 'FileRequestEntity', id: string, userId?: string | null, firmAccountId?: string | null, clientId?: string | null, notes?: string | null, title?: string | null, compiledHash?: string | null, signedFileId?: string | null, compiledFileId?: string | null, taxYearInterviewId: string, taskId?: string | null, signatureRequest?: any | null, signatureComplete?: any | null, createAt: any, updateAt: any, FileApprovals?: Array<{ __typename?: 'FileApprovalEntity', id: string, expiresAt: any, fileRequestId: string, email: string, name: string, kbaEnable: boolean, completedAt?: any | null, createAt: any, updateAt: any }> | null, SignedFile?: { __typename?: 'FileEntity', id: string, s3Key?: string | null, name?: string | null, folder?: string | null, createAt: any, updateAt: any, size?: number | null } | null }> | null }> };

export type GetOtpBooleanQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOtpBooleanQuery = { __typename?: 'Query', GetOTPBoolean: { __typename?: 'UserSuccessEntity', success: boolean } };

export type GetProgressStatusesByFirmAccountQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetProgressStatusesByFirmAccountQuery = { __typename?: 'Query', FirmAccountById: { __typename?: 'FirmAccountEntity', ProgressStatuses?: Array<{ __typename?: 'ProgressStatusesEntity', id: string, underlyingStatus: Types.TaxYearStatus }> | null } };

export type PhonesQueryVariables = Types.Exact<{
  userInformationId: Types.Scalars['String'];
}>;


export type PhonesQuery = { __typename?: 'Query', Phones: Array<{ __typename?: 'PhonesEntity', id: string, type: Types.PhoneType, value: string }> };

export type GetFirmSettingQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type GetFirmSettingQuery = { __typename?: 'Query', getFirmSetting: { __typename?: 'FirmSettingsEntity', id?: string | null, name: string, description: string, type: Types.SettingsType, value: { __typename?: 'BooleanValue', boolValue: boolean } | { __typename?: 'DateValue', dateValue: any } | { __typename?: 'NumberValue', numValue: number } | { __typename?: 'StringValue', strValue: string } } };


export const GetCustomLayoutsDocument = gql`
    query GetCustomLayouts {
  CustomLayout {
    id
    firmAccountId
    headerBackgroundColor
    headerFontColor
    logo
    pixelCode
  }
}
    `;

/**
 * __useGetCustomLayoutsQuery__
 *
 * To run a query within a React component, call `useGetCustomLayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomLayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomLayoutsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomLayoutsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>(GetCustomLayoutsDocument, options);
      }
export function useGetCustomLayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>(GetCustomLayoutsDocument, options);
        }
export type GetCustomLayoutsQueryHookResult = ReturnType<typeof useGetCustomLayoutsQuery>;
export type GetCustomLayoutsLazyQueryHookResult = ReturnType<typeof useGetCustomLayoutsLazyQuery>;
export type GetCustomLayoutsQueryResult = Apollo.QueryResult<GetCustomLayoutsQuery, GetCustomLayoutsQueryVariables>;
export const GenerateOtpDocument = gql`
    query GenerateOTP {
  generateOTP {
    codeQR
    key
  }
}
    `;

/**
 * __useGenerateOtpQuery__
 *
 * To run a query within a React component, call `useGenerateOtpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOtpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOtpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGenerateOtpQuery(baseOptions?: Apollo.QueryHookOptions<GenerateOtpQuery, GenerateOtpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOtpQuery, GenerateOtpQueryVariables>(GenerateOtpDocument, options);
      }
export function useGenerateOtpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOtpQuery, GenerateOtpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOtpQuery, GenerateOtpQueryVariables>(GenerateOtpDocument, options);
        }
export type GenerateOtpQueryHookResult = ReturnType<typeof useGenerateOtpQuery>;
export type GenerateOtpLazyQueryHookResult = ReturnType<typeof useGenerateOtpLazyQuery>;
export type GenerateOtpQueryResult = Apollo.QueryResult<GenerateOtpQuery, GenerateOtpQueryVariables>;
export const GetLanguagesDocument = gql`
    query GetLanguages {
  languages {
    id
    lang
    description
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetJobsByClientIdDocument = gql`
    query GetJobsByClientId($clientId: String!, $firmAccountId: String!) {
  jobsByClientId(clientId: $clientId, firmAccountId: $firmAccountId) {
    id
    taxYearId
    preparedId
    reviewedId
    notes
    assignedAt
    completedAt
    reviewStatus
    preparerAcceptedAt
    createAt
    updateAt
    PreparedUser {
      id
      email
      uniqueLink
      UserInformation {
        firstName
        lastName
      }
    }
    ReviewedUser {
      id
      email
      UserInformation {
        firstName
        lastName
      }
    }
    Interviews {
      id
      firmAccountId
      name
      isTemplate
      isLive
      drakePackage
      createAt
      updateAt
    }
    Reviews {
      id
      reviewValue
      taxYearInterviewId
    }
    ProgressStatuses {
      id
      firmAccountId
      status
      underlyingStatus
      createAt
      updateAt
    }
    Tasks {
      id
      taxYearInterviewId
      taskType
      completedAt
      deletedAt
      createAt
      updateAt
      RequestedFiles {
        taskId
        fileName
        notes
        completedAt
      }
    }
    FileRequests {
      id
      userId
      firmAccountId
      clientId
      notes
      title
      compiledHash
      signedFileId
      compiledFileId
      taxYearInterviewId
      taskId
      signatureRequest
      signatureComplete
      createAt
      updateAt
    }
    TaxYear {
      id
      year
      Entity {
        id
        UserFirmAccount {
          id
          FirmAccount {
            id
            name
            ownerId
            uniqueLink
          }
        }
      }
    }
  }
  FirmAccountById(id: $firmAccountId) {
    id
    ownerId
  }
}
    `;

/**
 * __useGetJobsByClientIdQuery__
 *
 * To run a query within a React component, call `useGetJobsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      firmAccountId: // value for 'firmAccountId'
 *   },
 * });
 */
export function useGetJobsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobsByClientIdQuery, GetJobsByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsByClientIdQuery, GetJobsByClientIdQueryVariables>(GetJobsByClientIdDocument, options);
      }
export function useGetJobsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsByClientIdQuery, GetJobsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsByClientIdQuery, GetJobsByClientIdQueryVariables>(GetJobsByClientIdDocument, options);
        }
export type GetJobsByClientIdQueryHookResult = ReturnType<typeof useGetJobsByClientIdQuery>;
export type GetJobsByClientIdLazyQueryHookResult = ReturnType<typeof useGetJobsByClientIdLazyQuery>;
export type GetJobsByClientIdQueryResult = Apollo.QueryResult<GetJobsByClientIdQuery, GetJobsByClientIdQueryVariables>;
export const GetFilesByTaxYearInterviewIdDocument = gql`
    query GetFilesByTaxYearInterviewId($taxYearInterviewId: String!) {
  FilesByTaxYearInterviewId(taxYearInterviewId: $taxYearInterviewId) {
    id
    s3Key
    name
    folder
    createAt
    updateAt
    size
    SignedFile {
      id
      userId
      firmAccountId
      clientId
      notes
      title
      compiledHash
      signedFileId
      compiledFileId
      taxYearInterviewId
      taskId
      signatureRequest
      signatureComplete
      createAt
      updateAt
      FileApprovals {
        id
        expiresAt
        fileRequestId
        email
        name
        kbaEnable
        completedAt
        createAt
        updateAt
      }
    }
    CompiledFile {
      id
      userId
      firmAccountId
      clientId
      notes
      title
      compiledHash
      signedFileId
      compiledFileId
      taxYearInterviewId
      taskId
      signatureRequest
      signatureComplete
      createAt
      updateAt
      FileApprovals {
        id
        expiresAt
        fileRequestId
        email
        name
        kbaEnable
        completedAt
        createAt
        updateAt
      }
      SignedFile {
        id
        s3Key
        name
        folder
        createAt
        updateAt
        size
      }
    }
  }
}
    `;

/**
 * __useGetFilesByTaxYearInterviewIdQuery__
 *
 * To run a query within a React component, call `useGetFilesByTaxYearInterviewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesByTaxYearInterviewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesByTaxYearInterviewIdQuery({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useGetFilesByTaxYearInterviewIdQuery(baseOptions: Apollo.QueryHookOptions<GetFilesByTaxYearInterviewIdQuery, GetFilesByTaxYearInterviewIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesByTaxYearInterviewIdQuery, GetFilesByTaxYearInterviewIdQueryVariables>(GetFilesByTaxYearInterviewIdDocument, options);
      }
export function useGetFilesByTaxYearInterviewIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesByTaxYearInterviewIdQuery, GetFilesByTaxYearInterviewIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesByTaxYearInterviewIdQuery, GetFilesByTaxYearInterviewIdQueryVariables>(GetFilesByTaxYearInterviewIdDocument, options);
        }
export type GetFilesByTaxYearInterviewIdQueryHookResult = ReturnType<typeof useGetFilesByTaxYearInterviewIdQuery>;
export type GetFilesByTaxYearInterviewIdLazyQueryHookResult = ReturnType<typeof useGetFilesByTaxYearInterviewIdLazyQuery>;
export type GetFilesByTaxYearInterviewIdQueryResult = Apollo.QueryResult<GetFilesByTaxYearInterviewIdQuery, GetFilesByTaxYearInterviewIdQueryVariables>;
export const GetOtpBooleanDocument = gql`
    query GetOTPBoolean {
  GetOTPBoolean {
    success
  }
}
    `;

/**
 * __useGetOtpBooleanQuery__
 *
 * To run a query within a React component, call `useGetOtpBooleanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpBooleanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpBooleanQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOtpBooleanQuery(baseOptions?: Apollo.QueryHookOptions<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>(GetOtpBooleanDocument, options);
      }
export function useGetOtpBooleanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>(GetOtpBooleanDocument, options);
        }
export type GetOtpBooleanQueryHookResult = ReturnType<typeof useGetOtpBooleanQuery>;
export type GetOtpBooleanLazyQueryHookResult = ReturnType<typeof useGetOtpBooleanLazyQuery>;
export type GetOtpBooleanQueryResult = Apollo.QueryResult<GetOtpBooleanQuery, GetOtpBooleanQueryVariables>;
export const GetProgressStatusesByFirmAccountDocument = gql`
    query GetProgressStatusesByFirmAccount($id: String!) {
  FirmAccountById(id: $id) {
    ProgressStatuses {
      id
      underlyingStatus
    }
  }
}
    `;

/**
 * __useGetProgressStatusesByFirmAccountQuery__
 *
 * To run a query within a React component, call `useGetProgressStatusesByFirmAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressStatusesByFirmAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressStatusesByFirmAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgressStatusesByFirmAccountQuery(baseOptions: Apollo.QueryHookOptions<GetProgressStatusesByFirmAccountQuery, GetProgressStatusesByFirmAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressStatusesByFirmAccountQuery, GetProgressStatusesByFirmAccountQueryVariables>(GetProgressStatusesByFirmAccountDocument, options);
      }
export function useGetProgressStatusesByFirmAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressStatusesByFirmAccountQuery, GetProgressStatusesByFirmAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressStatusesByFirmAccountQuery, GetProgressStatusesByFirmAccountQueryVariables>(GetProgressStatusesByFirmAccountDocument, options);
        }
export type GetProgressStatusesByFirmAccountQueryHookResult = ReturnType<typeof useGetProgressStatusesByFirmAccountQuery>;
export type GetProgressStatusesByFirmAccountLazyQueryHookResult = ReturnType<typeof useGetProgressStatusesByFirmAccountLazyQuery>;
export type GetProgressStatusesByFirmAccountQueryResult = Apollo.QueryResult<GetProgressStatusesByFirmAccountQuery, GetProgressStatusesByFirmAccountQueryVariables>;
export const PhonesDocument = gql`
    query Phones($userInformationId: String!) {
  Phones(userInformationId: $userInformationId) {
    id
    type
    value
  }
}
    `;

/**
 * __usePhonesQuery__
 *
 * To run a query within a React component, call `usePhonesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhonesQuery({
 *   variables: {
 *      userInformationId: // value for 'userInformationId'
 *   },
 * });
 */
export function usePhonesQuery(baseOptions: Apollo.QueryHookOptions<PhonesQuery, PhonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PhonesQuery, PhonesQueryVariables>(PhonesDocument, options);
      }
export function usePhonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PhonesQuery, PhonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PhonesQuery, PhonesQueryVariables>(PhonesDocument, options);
        }
export type PhonesQueryHookResult = ReturnType<typeof usePhonesQuery>;
export type PhonesLazyQueryHookResult = ReturnType<typeof usePhonesLazyQuery>;
export type PhonesQueryResult = Apollo.QueryResult<PhonesQuery, PhonesQueryVariables>;
export const GetFirmSettingDocument = gql`
    query getFirmSetting($name: String!) {
  getFirmSetting(name: $name) {
    id
    name
    description
    type
    value {
      ... on BooleanValue {
        boolValue: val
      }
      ... on NumberValue {
        numValue: val
      }
      ... on DateValue {
        dateValue: val
      }
      ... on StringValue {
        strValue: val
      }
    }
  }
}
    `;

/**
 * __useGetFirmSettingQuery__
 *
 * To run a query within a React component, call `useGetFirmSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmSettingQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFirmSettingQuery(baseOptions: Apollo.QueryHookOptions<GetFirmSettingQuery, GetFirmSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmSettingQuery, GetFirmSettingQueryVariables>(GetFirmSettingDocument, options);
      }
export function useGetFirmSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmSettingQuery, GetFirmSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmSettingQuery, GetFirmSettingQueryVariables>(GetFirmSettingDocument, options);
        }
export type GetFirmSettingQueryHookResult = ReturnType<typeof useGetFirmSettingQuery>;
export type GetFirmSettingLazyQueryHookResult = ReturnType<typeof useGetFirmSettingLazyQuery>;
export type GetFirmSettingQueryResult = Apollo.QueryResult<GetFirmSettingQuery, GetFirmSettingQueryVariables>;
export const namedOperations = {
  Query: {
    GetCustomLayouts: 'GetCustomLayouts',
    GenerateOTP: 'GenerateOTP',
    GetLanguages: 'GetLanguages',
    GetJobsByClientId: 'GetJobsByClientId',
    GetFilesByTaxYearInterviewId: 'GetFilesByTaxYearInterviewId',
    GetOTPBoolean: 'GetOTPBoolean',
    GetProgressStatusesByFirmAccount: 'GetProgressStatusesByFirmAccount',
    Phones: 'Phones',
    getFirmSetting: 'getFirmSetting'
  }
}